import axios from 'axios';

class ConfigService {
    getConfig() {
        return axios.get(`${process.env.PUBLIC_URL}/config.json`).then(resp => resp.data);
    }
}

export default new ConfigService();
